import { FC, ReactNode, ComponentProps } from 'react';
import { withStyles, MaterialSymbol } from 'vopay';
import styles from './Chip.module.scss';

const cn = withStyles(styles);

type IconProps = ComponentProps<typeof MaterialSymbol>;

type ChipProps = {
  disabled?: boolean;
  label: ReactNode;
  onClick?: () => void;
  iconLeft?: IconProps['icon'];
  iconLeftProps?: IconProps;
  iconRight?: IconProps['icon'];
  iconRightProps?: IconProps;
  className?: string;
};

const Chip: FC<ChipProps> = ({
  disabled = false,
  label,
  onClick,
  iconRight,
  iconRightProps,
  iconLeft,
  iconLeftProps,
  className,
}) => {
  function renderContents() {
    return (
      <>
        {iconLeft && <MaterialSymbol className={cn('icon')} icon={iconLeft} />}
        {iconLeftProps && <MaterialSymbol {...iconLeftProps} className={cn('icon', iconLeftProps.className)} />}
        <div className={cn('label')}>{label}</div>
        {iconRight && <MaterialSymbol className={cn('icon')} icon={iconRight} />}
        {iconRightProps && <MaterialSymbol {...iconRightProps} className={cn('icon', iconRightProps.className)} />}
      </>
    );
  }

  if (onClick && !disabled) {
    return (
      <button className={cn('chip', className)} onClick={onClick}>
        {renderContents()}
      </button>
    );
  }

  return <div className={cn('chip', className)}>{renderContents()}</div>;
};

export default Chip;
